export default __webpack_public_path__ + "static/topic3-ffda4fc3727cdff90cf179356849f9d0.png";